import { Component, OnInit, EventEmitter, Output } from '@angular/core';

@Component({
  selector: 'inc-patient-order',
  templateUrl: './patient-order.component.html',
  styleUrls: ['./patient-order.component.scss'],
})
export class PatientOrderComponent {
  order: string;
  orderIcon: string;

  @Output() callSearch = new EventEmitter<string>();

  constructor() { }

  orderMouseEnter() {
    if (!this.order) {
      this.orderIcon = 'arrow-round-up';
    }
  }

  orderMouseLeave() {
    if (!this.order) {
      this.orderIcon = undefined;
    }
  }

  swap() {
    switch (this.order) {
      case 'asc':
        this.order = 'desc';
        this.orderIcon = 'arrow-round-down';
        break;
      case 'desc':
        this.order = undefined;
        this.orderIcon = undefined;
        break;
      default:
        this.order = 'asc';
        this.orderIcon = 'arrow-round-up';
        break;
    }
    this.callSearch.emit(this.order);
  }

}
